import { openBlock, createElementBlock, normalizeClass, renderSlot, createTextVNode, toDisplayString, createCommentVNode, createElementVNode, createVNode, Transition, withCtx, withKeys, Fragment, renderList, getCurrentInstance } from "vue";
var KEY_RETURN = 13;
var KEY_ESCAPE = 27;
var KEY_SPACE = 32;
var KEY_LEFT = 37;
var KEY_UP = 38;
var KEY_RIGHT = 39;
var KEY_DOWN = 40;
var config = {
  transition: null
};
const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "v-select__inner" };
const _hoisted_3 = ["id", "disabled", "aria-expanded", "aria-labelledby"];
const _hoisted_4 = {
  key: 0,
  class: "v-select__prepend"
};
const _hoisted_5 = {
  key: 1,
  class: "v-select__placeholder"
};
const _hoisted_6 = { class: "v-select__selected" };
const _hoisted_7 = { class: "v-select__arrow" };
const _hoisted_8 = /* @__PURE__ */ createElementVNode("svg", { viewBox: "0 0 255 255" }, [
  /* @__PURE__ */ createElementVNode("path", { d: "M0 64l128 127L255 64z" })
], -1);
const _hoisted_9 = {
  key: 0,
  class: "v-select__menu"
};
const _hoisted_10 = ["aria-activedescendant", "aria-labelledby"];
const _hoisted_11 = ["id", "onMousedown", "aria-selected"];
const _hoisted_12 = {
  key: 1,
  class: "v-select__no-options"
};
const _hoisted_13 = /* @__PURE__ */ createElementVNode("span", null, "No options provided", -1);
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["v-select", $options.className])
  }, [
    $options.hasSlot("label") || $props.label ? (openBlock(), createElementBlock("span", {
      key: 0,
      class: "v-select__label",
      id: $options.labelId
    }, [
      renderSlot(_ctx.$slots, "label", {}, () => [
        createTextVNode(toDisplayString($props.label) + ":", 1)
      ])
    ], 8, _hoisted_1)) : createCommentVNode("", true),
    createElementVNode("div", _hoisted_2, [
      createElementVNode("button", {
        class: "v-select__btn",
        id: $options.buttonId,
        ref: "button",
        disabled: $props.disabled,
        "aria-expanded": $options.ariaExpanded,
        "aria-labelledby": `${$options.labelId ? $options.labelId : ""} ${$options.buttonId}`,
        type: "button",
        "aria-haspopup": "listbox",
        onMousedown: _cache[0] || (_cache[0] = (...args) => $options.toggle && $options.toggle(...args)),
        onKeydown: _cache[1] || (_cache[1] = (...args) => $options.keydownHandler && $options.keydownHandler(...args)),
        onBlur: _cache[2] || (_cache[2] = (...args) => $options.buttonBlurHandler && $options.buttonBlurHandler(...args))
      }, [
        $options.hasSlot("prepend") ? (openBlock(), createElementBlock("span", _hoisted_4, [
          renderSlot(_ctx.$slots, "prepend")
        ])) : createCommentVNode("", true),
        ($props.placeholder || $options.hasSlot("placeholder")) && $props.value === void 0 || !$options.optionsHasValue ? (openBlock(), createElementBlock("span", _hoisted_5, [
          renderSlot(_ctx.$slots, "placeholder", { placeholder: $props.placeholder }, () => [
            createTextVNode(toDisplayString($props.placeholder), 1)
          ])
        ])) : createCommentVNode("", true),
        createElementVNode("span", _hoisted_6, [
          $props.value !== void 0 && $options.optionsHasValue ? renderSlot(_ctx.$slots, "selected", {
            key: 0,
            value: $props.value,
            option: $options.currentOption
          }, () => [
            createTextVNode(toDisplayString($options.currentOption ? $options.currentOption.label : $props.value), 1)
          ]) : createCommentVNode("", true)
        ]),
        createElementVNode("span", _hoisted_7, [
          renderSlot(_ctx.$slots, "arrow", {}, () => [
            _hoisted_8
          ])
        ])
      ], 40, _hoisted_3),
      createVNode(Transition, {
        name: $props.transition ? $props.transition.name : "",
        mode: $props.transition ? $props.transition.mode : ""
      }, {
        default: withCtx(() => [
          $data.open ? (openBlock(), createElementBlock("div", _hoisted_9, [
            $props.options && $props.options.length ? (openBlock(), createElementBlock("ul", {
              key: 0,
              class: "v-select__list",
              ref: "list",
              "aria-activedescendant": $props.value && $options.getOptionId($props.value),
              "aria-labelledby": $options.labelId,
              role: "listbox",
              tabindex: "-1",
              onKeydown: _cache[3] || (_cache[3] = (...args) => $options.keydownHandler && $options.keydownHandler(...args)),
              onKeyup: [
                _cache[4] || (_cache[4] = withKeys((...args) => $options.setLastSelected && $options.setLastSelected(...args), ["end"])),
                _cache[5] || (_cache[5] = withKeys((...args) => $options.setFirstSelected && $options.setFirstSelected(...args), ["home"])),
                _cache[6] || (_cache[6] = withKeys((...args) => $options.escapeHandler && $options.escapeHandler(...args), ["esc"]))
              ],
              onBlur: _cache[7] || (_cache[7] = (...args) => $options.menuBlurHandler && $options.menuBlurHandler(...args))
            }, [
              (openBlock(true), createElementBlock(Fragment, null, renderList($props.options, (option, index) => {
                return openBlock(), createElementBlock("li", {
                  class: normalizeClass(["v-select__option", { "v-select__option--selected": $options.isSelected(option) }]),
                  key: index,
                  id: $options.getOptionId(option),
                  role: "option",
                  ref_for: true,
                  ref: "options",
                  onMousedown: ($event) => $options.clickHandler(option),
                  "aria-selected": $options.isSelected(option) ? "true" : "false"
                }, [
                  renderSlot(_ctx.$slots, "option", {
                    option,
                    value: $props.value
                  }, () => [
                    createElementVNode("span", null, toDisplayString(option.label), 1)
                  ])
                ], 42, _hoisted_11);
              }), 128))
            ], 40, _hoisted_10)) : (openBlock(), createElementBlock("div", _hoisted_12, [
              renderSlot(_ctx.$slots, "no-optioms", {}, () => [
                _hoisted_13
              ])
            ]))
          ])) : createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["name", "mode"])
    ])
  ], 2);
}
var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _sfc_main = {
  name: "VueAccessibleSelect",
  props: {
    options: {
      type: Array,
      required: true
    },
    value: {
      required: true
    },
    transition: {
      type: Object,
      default: () => config.transition || {}
    },
    label: String,
    placeholder: String,
    disabled: Boolean
  },
  emits: ["change", "open", "close", "input"],
  data() {
    const _vm = getCurrentInstance();
    return {
      open: false,
      timeout: null,
      printedText: "",
      localId_: _vm.uid,
      _vm
    };
  },
  computed: {
    labelId() {
      return this.label ? `v-select-label-${this.localId_}` : false;
    },
    buttonId() {
      return `v-select-button-${this.localId_}`;
    },
    ariaExpanded() {
      return this.open ? "true" : "false";
    },
    className() {
      return {
        "v-select--opened": this.open,
        "v-select--disabled": this.disabled
      };
    },
    currentOption() {
      return Array.isArray(this.options) && this.options.find((option) => option.value === this.value);
    },
    currentOptionIndex() {
      return this.options.findIndex((option) => option === this.currentOption);
    },
    optionsHasValue() {
      return this.options.findIndex((option) => option.value === this.value) !== -1;
    }
  },
  watch: {
    open(val) {
      if (val) {
        setTimeout(() => {
          document.addEventListener("click", this.clickListener);
          const { list } = this.$refs;
          if (list) {
            list.focus();
            const { value } = this;
            if (value || value === 0) {
              this.scrollToSelected();
            }
          }
          this.$emit("open");
        }, 0);
      } else {
        document.removeEventListener("click", this.clickListener);
        this.$emit("close");
      }
    },
    value(val) {
      if (val || val == 0) {
        this.scrollToSelected();
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.localId_ = this._vm.uid;
    });
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
    emit(val) {
      this.$emit("input", val);
      this.$emit("change", val);
    },
    clickListener(e) {
      const { target } = e;
      const closestBtn = target.closest(".v-select__btn");
      const closestList = target.closest(".v-select__list");
      if (closestList === this.$refs.list || closestBtn === this.$refs.button)
        ;
      else {
        this.open = false;
      }
    },
    isSelected(option) {
      return this.value === option.value;
    },
    clickHandler(option) {
      this.emit(option.value);
      this.open = false;
    },
    async keydownHandler(e) {
      if (e.keyCode === KEY_ESCAPE) {
        return;
      }
      if ([KEY_SPACE, KEY_LEFT, KEY_UP, KEY_RIGHT, KEY_DOWN].indexOf(e.keyCode) > -1) {
        e.preventDefault();
      }
      const { currentOptionIndex } = this;
      switch (e.keyCode) {
        case KEY_SPACE:
          this.open = true;
          break;
        case KEY_UP:
          if (currentOptionIndex !== 0)
            this.emit(this.options[currentOptionIndex - 1].value);
          return;
        case KEY_DOWN:
          if (currentOptionIndex !== this.options.length - 1)
            this.emit(this.options[currentOptionIndex + 1].value);
          return;
        case KEY_RETURN:
          this.toggle();
          await this.$nextTick();
          if (!this.open)
            this.$refs.button.focus();
      }
      this.printHandler(e);
    },
    getOptionId(option) {
      return `v-select-option-${this.options.indexOf(option)}_${this.localId_}`;
    },
    setFirstSelected() {
      this.emit(this.options[0].value);
    },
    setLastSelected() {
      this.emit(this.options[this.options.length - 1].value);
    },
    escapeHandler() {
      this.open = false;
      this.$refs.button.focus();
    },
    printHandler(e) {
      const newChar = e.key ? e.key : String.fromCharCode(e.keyCode);
      if (newChar.length > 1)
        return;
      this.printedText += newChar.toUpperCase();
      this.selectByText(this.printedText);
      clearTimeout(this.timeout);
      this.timeout = null;
      this.timeout = setTimeout(() => {
        this.printedText = "";
      }, 500);
    },
    selectByText(text) {
      for (let option of this.shiftOptions(this.currentOptionIndex)) {
        if (!String(option.label).toUpperCase().startsWith(text))
          continue;
        if (!this.currentOption) {
          this.emit(option.value);
          return;
        }
        if (this.currentOption.value !== option.value) {
          this.emit(option.value);
          return;
        }
      }
    },
    scrollToSelected() {
      if (Array.isArray(this.$refs.options)) {
        const currentOption = this.$refs.options[this.currentOptionIndex];
        if (currentOption) {
          const { offsetTop, clientHeight } = currentOption;
          const { list } = this.$refs;
          const currentVisibleArea = list.scrollTop + list.clientHeight;
          if (offsetTop < list.scrollTop) {
            list.scrollTop = offsetTop;
          } else if (offsetTop + clientHeight > currentVisibleArea) {
            list.scrollTop = offsetTop - list.clientHeight + clientHeight;
          }
        }
      }
    },
    buttonBlurHandler(e) {
      let target = e.relatedTarget;
      if (target === null) {
        target = document.activeElement;
      }
      if (target !== this.$refs.list && this.open) {
        this.open = false;
      }
    },
    menuBlurHandler(e) {
      let target = e.relatedTarget;
      if (target === null) {
        target = document.activeElement;
      }
      if (target !== this.$refs.button) {
        this.open = false;
      }
    },
    hasSlot(name) {
      return Boolean(this.$slots[name]);
    },
    shiftOptions(selectedIndex) {
      const { options } = this;
      if (selectedIndex === -1 || this.timeout) {
        return options;
      }
      const optionsBeforeSelected = options.slice(0, selectedIndex - 1);
      const optionsAfterSelected = options.slice(selectedIndex + 1, options.length);
      return [...optionsAfterSelected, ...optionsBeforeSelected];
    }
  }
};
var VueAccessibleSelect = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", render]]);
const Plugin = {
  install(app) {
    app.component("VueAccessibleSelect", VueAccessibleSelect);
  }
};
export { VueAccessibleSelect, config, Plugin as default };
